import React, { createContext, PropsWithChildren } from 'react';
import { Brand } from '@retail/auth/types';
import { Logos } from '@retail/utils';

export const MpeTenantHeader = 'X-Tenant' as const;
export const selectedBrandKey = 'selectedBrandKey';

type BrandsState = {
  availableBrands: Brand[];
  availableBrandsForChosenTenant: Brand[];
  selectedBrand: Brand;
  selectedBrandLogos: Logos;
  switchBrand: (brand: Brand) => void;
};

export const BrandsContext = createContext<BrandsState | null>(null);

interface Props extends PropsWithChildren {
  value: BrandsState;
}

export const BrandsProvider: React.FC<Props> = ({ children, value }) => (
  <BrandsContext.Provider value={value}>{children}</BrandsContext.Provider>
);
